export const PLACEHOLDER = {
  PORTRAIT_MOTIF: 'Au cas où vous voulez invalider le portrait, merci de saisir le motif',
  DOCUMENT_MOTIF: 'Au cas où vous voulez invalider le document, merci de saisir le motif'
};
